import React from 'react';

const Header = ({ first_name, last_name, email }) => (
  <div className="admin-profile-card-header">
      <h2>{`${first_name} ${last_name}`}</h2><p>{email}</p>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserHeader.js